import React from 'react'

const Unauthorized = () => {
    return (<div style={{textAlign:"center", marginTop:"25%", color:"red"}}><h1>Unauthorized Domain</h1></div>)

}

export default Unauthorized
